import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    Box,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    Card,
    CardHeader,
    Avatar,
    Divider,
    CardContent,
    Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { axiosFetch } from "../../../../utils/AxiosFetch";

// import required css from library
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from 'prop-types';
import '../../OKRs/OKRs.css';
import { Close } from '@mui/icons-material';
import { CustomizedSnackbar } from '../../../../shared/index';
import { useDispatch } from "react-redux";
import { SnackbarActions } from "../../../../redux/actions/snackbar.actions";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    // ValidatorForm.addValidationRule("")
    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};


const ReviewForm = (props) => {

    console.log(props)

    const open = props && props.open;
    const id = props && props.formId;
    const navigate = useNavigate();
    const dispatch = useDispatch();


    const handleApproval = () => {
        axiosFetch({
            method: 'post',
            url: `/performance/review/complete/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    dispatch(SnackbarActions(true, "success", 'Request Made Successfully'));
                    props.toggleConfirmPopup(2);
                    setTimeout(() => {
                        navigate('/performance');
                    }, 3000);
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", `${res.data}`));
                }

                else if (res.status === 401) {
                    navigate('/');
                }
            })
    }
    const handleSubmit = () => {
        axiosFetch({
            method: "post",
            url: `/Performance/review/submit/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    dispatch(SnackbarActions(true, 'success', 'Form Submitted'));
                    props.toggleConfirmPopup(2);
                    setTimeout(() => {
                        navigate('/performance');
                    }, 2000);

                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }

                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch(err => {
                console.error(err);
            })
    }


    useEffect(() => {

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (

        <React.Fragment>

            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth="sm"
                maxWidth="sm"
                onClose={() => props.toggleConfirmPopup(2)}
            >


                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={() => props.toggleConfirmPopup(2)}
                    className="modal-heading"
                >
                    Review Score
                </BootstrapDialogTitle>

                <DialogContent dividers>
                    <Box
                        className="review-form"
                        component="form"
                        autoComplete="off"
                    >
                        <Alert severity="error">Once you submit the Score, you cannot revert / modify the form.</Alert><Divider sx={{ margin: "15px 0 !important" }} />
                        <h3 className="review-form-title">OKR Score - {props && props.scoreList !== undefined && props.scoreList !== null && props.scoreList.okrScore !== null ? props.scoreList.okrScore + "/40" : "-"}</h3>
                        <h3 className="review-form-title">Performance Score - {props && props.scoreList !== undefined && props.scoreList !== null && props.scoreList.voiceScore !== null ? props.scoreList.voiceScore + "/40" : "-"}</h3>
                        <h3 className="review-form-title">Training & Development Score - {props && props.scoreList !== undefined && props.scoreList !== null && props.scoreList.trainingScore !== null ? props.scoreList.trainingScore + "/20" : "-"}</h3>
                        <Divider sx={{ margin: "15px 0 !important" }} />
                        <h4 className="score-review">Overall Score - {props && props.scoreList !== undefined && props.scoreList !== null && props.scoreList.overAllScore !== null ? props.scoreList.overAllScore + "/100" : "-"} </h4>
                        {props && props.scoreList !== undefined && props.scoreList !== null && props.scoreList.proposedPercentage !== null && props.scoreList.proposedPercentage !== -1 ?
                            <h4 className="score-review">Proposed % - {props && props.scoreList !== undefined && props.scoreList !== null && props.scoreList.proposedPercentage !== null ? props.scoreList.proposedPercentage + "%" : "-"}</h4>
                            : <h4 className="score-review">Proposed % - Not Applicable(Employee has been with the company for less than 6 months)</h4>
                        }
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => props.toggleConfirmPopup(2)} className="theme-btn cancel-btn" variant="contained">Cancel</Button>

                    {props && props.scoreList !== undefined && props.scoreList !== null && props.scoreList.statusId !== null && props.scoreList.statusId === 3 ? (<Button disabled={true}>Waiting for Approval</Button>) : (<Button variant="contained" className="theme-btn" onClick={props?.scoreList?.statusId === 4 ? handleSubmit : handleApproval}>{props?.scoreList?.statusId === 4 ? 'Submit for Employee final review' : 'Submit for Manager Approval'}</Button>)}

                </DialogActions>

            </BootstrapDialog>
            <CustomizedSnackbar />

        </React.Fragment >

    );
};




export default ReviewForm;
